/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question': {
    width: 16,
    height: 15,
    viewBox: '0 0 16 15',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M.667 7.5a7.333 7.333 0 1014.666 0 7.333 7.333 0 00-14.666 0zM14 7.5a6 6 0 11-12 0 6 6 0 0112 0zm-5.333 2.665a.667.667 0 11-1.333 0 .667.667 0 011.333 0zM7.333 8.833h1.334c0-.532.083-.63.631-.903.952-.476 1.369-.962 1.369-2.097C10.667 4.38 9.523 3.5 8 3.5a2.667 2.667 0 00-2.667 2.667h1.334c0-.737.597-1.334 1.333-1.334.852 0 1.333.371 1.333 1 0 .533-.083.63-.631.904-.952.476-1.369.962-1.369 2.096z" _fill="#005BA5"/>'
  }
})
